// extracted by mini-css-extract-plugin
export default {"line":"Notifications_line__yXG-+","title":"Notifications_title__fTS5y","tooltip":"Notifications_tooltip__fvV2w","switch":"Notifications_switch__l6QAj"};